module.exports = __webpack_public_path__ + "static/media/tulip.e1c861a2.svg";